export const ICON_LINK = [
	require('@app/images/arrow_circle.svg'),
	require('@app/images/text-button_link.svg'),
	require('@app/images/arrow_circle.svg'),
];

export const TEXT_LINK = ['Read more', 'Visit the site', 'Watch Now'];
